export const actions = {
    recaptchaLoaded({ commit }) {
        commit('recaptchaLoaded');
    },
}